'use client'
import React, { useState } from 'react'
import HeroSection from '@/components/industry-co-led/HeroSection';
import AboutProgram from '@/components/industry-co-led/AboutProgram';
import OurOffering from "@/components/industry-co-led/OurOffering"
import { MbaData } from '@/data/industry-co-led/redversity/Mbadata';
import { courseDetails } from '@/data/industry-co-led/redversity/courseDetails';
import WhySection from '@/components/industry-co-led/WhySection';
import MSUAdvantages from '@/components/industry-co-led/MSUAdvantages';
import CTASection from '@/components/industry-co-led/ui/CTASection';
import Eligibility from '@/components/industry-co-led/Eligibility';
import CurriculumStructure from "@/components/industry-co-led/CurriculumStructure";
import StudentStoriesSection from "@/components/industry-co-led/medhavianSpeak";
import FAQSection from "@/components/industry-co-led/FAQSection";
import InfrastructureSection from "@/components/industry-co-led/InfrastructureSection";
import AdditionalSkills from "@/components/industry-co-led/addintionSkill"
import OnTheJobTraining from '@/components/industry-co-led/OnTheJobTraining';
import UserFormModal from '@/components/industry-co-led/UserFormModal';
import { useFormModal } from "@/context/FormContext";
import VideoModal from '@/components/videoModel';
import CareerProspects from '@/components/industry-co-led/CareerProspects';
import EligibilitySection from '@/components/industry-co-led/EligibilitySection';
import CourseStickyBar from '@/components/industry-co-led/CourseSticky';
const MbaHealth = () => {
    const {
        isOpen,
        shouldDownload,
        closeForm,
        handleSuccess,
        openDownloadForm,
        openApplyForm,
        modal,
        closeVideo,
    } = useFormModal();

    const brochureUrl =
        "https://cdn.msu.edu.in/pdf/MSU_Fee_Structure_2026_27.pdf";

    const brochureName =
        "Master.pdf";

    return (
        <>
            <section className="w-full ">
                <HeroSection data={MbaData}
                    onDownload={() =>
                        openDownloadForm(
                            brochureUrl,
                            brochureName
                        )
                    }
                    onApply={() =>
                        openApplyForm()
                    }
                />
                <AboutProgram data={MbaData} />
                <OurOffering data={MbaData} />
                <WhySection data={MbaData} />
                <MSUAdvantages data={MbaData} />
                <CTASection data={MbaData}
                    onApplyNow={openApplyForm}
                />
                {/* <OnTheJobTraining
                    data={MbaData.onJobtrainningData}
                /> */}
                <AdditionalSkills courseSections={MbaData.addtionSkill.courseSections}
                    onApplyNow={openApplyForm}
                />
                <InfrastructureSection data={MbaData.DoExperienceLearndata} />
                <StudentStoriesSection studentStoriesData={MbaData.studentStoriesData} />
                <EligibilitySection data={MbaData} onApplyNow={openApplyForm}/>

                <CareerProspects data={MbaData.careerProspects}/>

                <CurriculumStructure curriculumData={MbaData.curriculumStructure} />
                <FAQSection course={MbaData.faq} />
            </section>

            <UserFormModal
                isOpen={isOpen}
                onClose={closeForm}
                onSuccess={handleSuccess}
                shouldDownload={shouldDownload}
                courseDetails={courseDetails.redversity.PG}
                specialization={"Healthcare Management"}
                course={"MBA (2 Years)"}
                schoolName={"Management & Commerce"}
                stream={""}
            />

            <VideoModal
                open={modal.open}
                url={modal.url}
                onClose={closeVideo}
            />
           <CourseStickyBar coursePrice={MbaData.coursePrice} onApply={() =>openApplyForm()}  />
            
        </>
    )
}

export default MbaHealth